import * as z from 'zod';

export const locationFormSchema = z.object({
  State: z.string().min(1, { message: 'STATE_REQUIRED' }),
});

export type LocationFormValues = z.infer<typeof locationFormSchema>;
